<template>
  <v-overlay class="mit-key-editor" :dark="false" opacity=".8" z-index="1000" :value="show">
    <v-container class="pa-30">
      <v-row>
        <v-col cols="12" class="d-flex justify-left">
          <v-card v-if="keyModel" class="card">
            <v-card-title><span class="text-h5">{{ title }}</span></v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                      <v-form :ref="'editForm'" v-model="valid" lazy-validation>
                          <v-text-field v-model="key.name" :rules="rules.name" label="Name" placeholder="Enter Name"></v-text-field>
                          <v-text-field v-model.number="key.count" type="number" label="Total Count" placeholder="Total Inventory Count"></v-text-field>
                          <!-- <v-combobox label="Type" :items="keyTypes" item-text="name" item-value="id" v-model="key.type" dense filled></v-combobox> -->

                          <v-autocomplete chips clearable deletable-chips multiple small-chips
                            label="Spaces"
                            v-model="key.spaces"
                            color="blue-grey lighten-2"
                            :items="spacesModel"
                            item-value="mitId"
                            item-text="mitId"
                            return-object
                          >
                          <template v-slot:selection="data">
                            <v-chip v-bind="data.attrs" :input-value="data.selected" close @click="data.select" @click:close="removeSpace(data.item)" >
                              {{ data.item.mitId }}
                            </v-chip>
                          </template>
                          <template v-slot:item="data">
                            <template v-if="typeof data.item !== 'object'">
                              <v-list-item-content v-text="data.item"></v-list-item-content>
                            </template>
                            <template v-else>
                                <v-list-item-avatar>
                                    <v-icon v-if="data.item.type === 'building'">mdi-office-building-outline</v-icon>
                                    <!-- <v-icon v-else>mdi-door-closed</v-icon> -->
                                    <v-icon v-else>mdi-door-sliding</v-icon>
                                </v-list-item-avatar>
                              <v-list-item-content>
                                  <v-list-item-title v-html="data.item.mitId"></v-list-item-title>
                                  <v-list-item-subtitle v-html="data.item.org"></v-list-item-subtitle>
                              </v-list-item-content>
                            </template>
                          </template>
                          </v-autocomplete>
                          <v-text-field :counter="100" v-if="key.data" v-model="key.data.notes" :rules="rules.notes" label="Notes" placeholder="Enter Notes"></v-text-field>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            <v-card-actions class="action">
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="cancel()">Cancel</v-btn>
              <v-btn :disabled="!valid" color="blue darken-1" text @click="save()">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-overlay>
</template>

<script>
  import MitKeysService from '../services/MitKeysService.js';

  export default {
    name: 'MitKeyEditor',
    components: {},
    props: {
      show: Boolean,
      keyModel: Object,
      existingKeyNames: Array,
      title: String,
      spacesModel: {
        type: Array,
        default: []
      },
    },
    watch: {
      keyModel: function (val) {
        //Handle Case of a brand new key, so no model passed in.
        if(typeof (val) !== 'undefined' && val !== null){
          this.setEditorValuesFromModel(val);
        }
      }
    },
    data: function() {
      return {
        key:{},
        keyTypes:MitKeysService.KEY_TYPES_ARRAY,
        valid:false,
        rules:{
          name:[
            v => !!v || 'Name is required',
            // v => v.indexOf(' ') === -1 || 'Spaces in name are not allowed',
            v => /^[a-z0-9\-]+$/i.test(v) || 'Only letters, numbers, and dashes are allowed',
            v => this.existingKeyNames.indexOf(v.toUpperCase()) === -1 || 'Key with this name already exists'
          ],
          notes:[
            v => v.length < 100 || 'Notes must be less than 1000 characters',
          ]
        }
      }
    },
    methods: {
      removeSpace (item) {
        let index = -1;
        for(let x = 0; x < this.key.spaces.length; x++){
          if(this.key.spaces[x].mitId === item.mitId){
            index = x;
            break;
          }
        }
        if (index >= 0) this.key.spaces.splice(index, 1)
      },
      setEditorValuesFromModel(keyModel){
        this.key.name = this.keyModel.name;
        this.key.count = this.keyModel.count;
        this.key.spaces = this.keyModel.spaces;
        this.key.data = this.keyModel.data;
        this.key.type = MitKeysService.KEY_TYPES[this.keyModel.type.id];

        if(typeof this.key.data.notes === 'undefined'){
          this.key.data.notes = '';
        }
      },
      save (){
        if(this.$refs.editForm.validate()){
          this.keyModel.name = this.key.name;
          this.keyModel.count = parseInt(this.key.count);
          this.keyModel.spaces = this.key.spaces;
          this.keyModel.data = this.key.data;
          this.keyModel.type = MitKeysService.KEY_TYPES[this.key.type.id];
          this.$emit('save', this.keyModel);
        }
      },
      cancel(){
        this.$emit('cancel');
      }
    }

  }
</script>

<style lang="scss" scoped>
  .card {
    // padding: 30px 30px 30px 30px;
    min-width: 600px;
  }
  @media only screen and (max-width: 599px)
  {
    .card {
    min-width: 200px;
    }
  }
  .action {
    padding-top: 50px;
  }
</style>
